import React from 'react';

const TermsOfService = () => {
  return (
    <main className="pt-24 pb-16 bg-white">
      <div className="container mx-auto px-4 max-w-4xl">
        <h1 className="text-4xl font-bold text-gray-900 mb-8">Terms of Service</h1>
        <div className="prose prose-blue max-w-none text-gray-600">
          <p className="mb-4">Last updated: {new Date().toLocaleDateString()}</p>
          
          <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4">1. Agreement to Terms</h2>
          <p>By accessing our website and services, you agree to be bound by these Terms of Service.</p>

          <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4">2. Intellectual Property</h2>
          <p>The content, features, and functionality of this website are owned by Teqvis Technologies and are protected by international copyright laws.</p>

          <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4">3. Use License</h2>
          <p>Permission is granted to temporarily download one copy of the materials on our website for personal, non-commercial transitory viewing only.</p>

          <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4">4. Limitation of Liability</h2>
          <p>In no event shall Teqvis Technologies be liable for any damages arising out of the use or inability to use the materials on our website.</p>

          <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4">5. Governing Law</h2>
          <p>These terms shall be governed by and construed in accordance with the laws of India.</p>
        </div>
      </div>
    </main>
  );
};

export default TermsOfService;
